<template>
  <v-app-bar app dense clipped-left clipped-right color="primary" dark
    :extension-height="ImpersonatingUser ? 34 : 0">

    <template v-slot:extension>
      <div v-if="ImpersonatingUser" class="imp-ext">
        <v-icon small color="#92400e" class="mr-2">mdi-incognito</v-icon>
        <span>Acting as: <strong>{{ ImpersonatingUser.name }}</strong></span>
        <v-spacer></v-spacer>
        <button class="imp-ext-stop" @click="stopImpersonating">
          <v-icon x-small style="margin-right:3px;">mdi-close-circle</v-icon>Stop
        </button>
      </div>
    </template>
    <v-app-bar-nav-icon
      class="d-block d-md-none"
      @click="$vuetify.breakpoint.smAndDown ? setSidebarDrawer(!Sidebar_drawer) : $emit('input', !value)"
    />
    <v-toolbar-title class="align-center d-flex">
      <span class="logo-text ">
        <img width="150" src="../assets/ENG LOGO PNG.png" class="mt-2" />
        <!-- <img src="../assets/logo.png" /> -->
      </span>
      
    </v-toolbar-title>

    <v-spacer />

    <!-- dual-swipe alert (only renders when an uncorrected detection exists for today) -->
    <DualSwipeAlert />

    <!-- notifications -->
    <v-btn dark icon @click="$store.state.Notification_drawer = !$store.state.Notification_drawer">
      <v-icon>mdi-bell</v-icon>
      <v-badge
        v-if="unReadNotifications > 0"
        :content="unReadNotifications > 99 ? '99+' : unReadNotifications"
        color="red lighten-1"
        overlap
      ></v-badge>
    </v-btn>

    <!-- Impersonate (super-admin only) — desktop bar; mobile gets it via the more-menu -->
    <v-btn class="d-none d-md-inline-flex" dark icon v-if="$can('all_permissions')" @click="impDialog = true">
      <v-icon :color="ImpersonatingUser ? 'amber' : ''">mdi-account-switch</v-icon>
      <v-badge v-if="ImpersonatingUser" color="amber" dot overlap></v-badge>
    </v-btn>

    <v-dialog v-if="$can('all_permissions')" v-model="impDialog" max-width="420px">
      <v-card>
        <v-card-title class="subtitle-2">
          <v-icon small class="mr-2">mdi-account-switch</v-icon>View as Staff
        </v-card-title>
        <v-card-text>
          <v-alert v-if="ImpersonatingUser" dense text type="warning" class="mb-3">
            Acting as <strong>{{ ImpersonatingUser.name }}</strong>
          </v-alert>
          <new-select-remote
            label="Search staff by name"
            :url="staffSearchUrl"
            option-label="LcEngStaffName"
            option-key="ISMID"
            :remote-search="true"
            mode="object"
            :value="null"
            @input="startImpersonating"
          />
          <div class="caption grey--text mt-1">
            All API calls will be scoped to the selected person.
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="ImpersonatingUser" small color="error" outlined @click="stopImpersonating">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>Stop
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small text @click="impDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn class="d-none d-md-inline-flex" dark icon @click="$refs.customQRCodeScanner.open()" v-if="$can('all_permissions')">
      <v-icon>mdi-qrcode-scan</v-icon>
    </v-btn>

    <a href="https://ticketing.pgo.mv" target="_blank" v-if="!$isMobile()">
      <v-btn dark icon>
        <v-icon>mdi-face-agent</v-icon>
      </v-btn>
    </a>

    <!-- <TicketModal ref="ticketModal" /> -->

    <CustomQRCodeScanner ref="customQRCodeScanner" @result="onDetect" />
    <AssetBelongsToModal ref="assetBelongsToModal" />

    <!-- Mobile fallback for the PGOApps grid (the toolbar v-menu is hidden on <md). -->
    <v-dialog v-model="showPGOAppsMobile" max-width="320" content-class="pgo-apps-mobile-dialog">
      <PGOApps />
    </v-dialog>

    <!-- pgo_apps — desktop only; mobile users access apps via the more-menu -->
    <v-menu class="d-none d-md-inline-flex" v-model="showPGOApps" :close-on-content-click="true" offset-y :nudge-width="250" bottom left transition="scale-transition" rounded="xl">
      <template v-slot:activator="{ on, attrs }">
          <v-btn class="d-none d-md-inline-flex" dark icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-grid</v-icon>
          </v-btn>
      </template>

      <PGOApps></PGOApps>
    </v-menu>


    <!-- <v-menu  offset-y :nudge-width="250" bottom left transition="scale-transition" rounded="xl">
      <template>
          <v-btn dark icon @click="$refs.customQRCodeScanner.open()">
            <v-icon>mdi-qrcode</v-icon>
          </v-btn>
      </template>

      <CustomQRCodeScanner ref="customQRCodeScanner" />
    </v-menu> -->

    <v-menu bottom left transition="scale-transition">
      <template v-slot:activator="{ on }" v-if="User">
        <!-- more manu -->
        <v-btn dark icon v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item href="https://ticketing.pgo.mv" target="_blank" dense v-if="$isMobile()">
          <v-list-item-icon>
            <v-icon>mdi-face-agent</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Ticketing</v-list-item-title>
        </v-list-item>
        <!-- Mobile-only entries for items hidden from the toolbar on small screens. -->
        <v-list-item v-if="$isMobile() && $can('all_permissions')" dense @click="impDialog = true">
          <v-list-item-icon>
            <v-icon :color="ImpersonatingUser ? 'amber' : ''">mdi-account-switch</v-icon>
          </v-list-item-icon>
          <v-list-item-title>View as Staff</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="$isMobile() && $can('all_permissions')" dense @click="$refs.customQRCodeScanner.open()">
          <v-list-item-icon>
            <v-icon>mdi-qrcode-scan</v-icon>
          </v-list-item-icon>
          <v-list-item-title>QR Scanner</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="$isMobile()" dense @click="showPGOAppsMobile = true">
          <v-list-item-icon>
            <v-icon>mdi-dots-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-title>PGO Apps</v-list-item-title>
        </v-list-item>
        <v-list-item v-for="(item, i) in userprofile" :key="i" @click="href(item)" dense>
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>


<script>
import PGOApps from './PGOApps.vue'
import DualSwipeAlert from './attendance/DualSwipeAlert.vue'
// Utilities
import { mapState, mapMutations } from "vuex";
import CustomQRCodeScanner from './util/CustomQRCodeScanner.vue';
import AssetBelongsToModal from './office-assets/AssetBelongsToModal.vue';

// import TicketModal from './ticketing/TicketModal.vue';

export default {
  name: "Header",

// TicketModal
  components: {PGOApps, CustomQRCodeScanner, AssetBelongsToModal, DualSwipeAlert, },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    impDialog: false,
    showPGOApps: false,
    showPGOAppsMobile: false,
    userprofile: [
      { title: "Profile", to: "/profile", icon: 'mdi-account-outline' },
      { title: "SMS Notifications", to: "/profile/sms-notifications", icon: 'mdi-message-text-outline' },
      { title: "Logout", to: "/api/logout", icon: 'mdi-logout' }
    ],
    href(item) {
      // return undefined;
      if(item.title == 'Logout')
        return window.location.href = item.to
      this.$router.push(item.to)
    }
  }),

  computed: {
    unReadNotifications() {
      if (this.$store.state.Notifications.length < 1) return 0
      let unRead = this.$store.state.Notifications.filter((item) => item.read_status == false)
      return unRead.length
    },
    ImpersonatingUser() { return this.$store.state.ImpersonatingUser },
    ...mapState(['Sidebar_drawer']),
  },

  methods: {
    staffSearchUrl(q) {
      // Use the app's canonical active-staff search endpoint. `/api/staff`
      // resolves to the RestShared catch-all → App\Models\Staff (MySQL
      // staff_master) with NO status filter — a rejoiner staff (same
      // person, one Resigned row + one new Active row) appears twice,
      // e.g. Arujoon Afeef with EMPNOs 0393 (Resigned 2022) and 0523
      // (Rejoined 2026-07-12). getAllStaffsFromHrms defaults to
      // Status='Active' server-side and searches name/EMPNO/NationalID.
      return `/api/staffs/getAllStaffsFromHrms?paginate=false&search=${encodeURIComponent(q)}`
    },
    startImpersonating(staff) {
      if (!staff) return
      this.$store.commit('SET_IMPERSONATING', { ISMID: staff.ISMID, name: staff.LcEngStaffName })
      window.location.reload()
    },
    stopImpersonating() {
      this.$store.commit('SET_IMPERSONATING', null)
      window.location.reload()
    },
    onDetect(text, result) {
      console.log(text)
      this.$refs.assetBelongsToModal.open(text)
    },
    ...mapMutations({
        setSidebarDrawer: "SET_SIDEBAR_DRAWER",
    })
  }
};
</script>

<style scoped>
.v-menu__content {
  margin-top: 10px !important;
  width: 400px;
}

/* Compact toolbar on mobile (<md). Reduces padding around v-app-bar contents and
 * shrinks v-btn[icon] so the remaining icons (logo + dual-swipe + bell + 3-dot)
 * sit comfortably on a phone. */
@media (max-width: 959px) {
  .v-app-bar >>> .v-toolbar__content {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .v-app-bar >>> .v-btn--icon.v-size--default {
    width: 32px !important;
    height: 32px !important;
  }
  .v-app-bar >>> .v-btn--icon .v-icon {
    font-size: 20px !important;
  }
}
.imp-ext {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0 12px;
  background: #fef3c7;
  color: #78350f;
  font-size: 12px;
  height: 34px;
}
.imp-ext-stop {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 6px;
  border: 1px solid #fbbf24;
  background: #fff;
  color: #92400e;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
}
.imp-ext-stop:hover { background: #fef3c7; }
</style>